const updateFrequencyStr = {
  toastr: 'Periodicidade atualizada',
  toastr1: 'foi atualizada com sucesso',
  toastrError: 'Periodicidade já cadastrada',
  toastrError1: 'Insira outro nome'
};

export default updateFrequencyStr;
